import { useState, useEffect } from 'react';
import { getImageFromDB } from '../db/imageDb';

export const useImage = (imageId?: string, fallbackUrl?: string) => {
  const [imageUrl, setImageUrl] = useState<string | null>(null);

  useEffect(() => {
    let active = true;
    let objectUrl: string | null = null;

    const load = async () => {
      if (imageId) {
        try {
          const blob = await getImageFromDB(imageId);
          if (blob && active) {
            objectUrl = URL.createObjectURL(blob);
            setImageUrl(objectUrl);
            return;
          }
        } catch (e) {
          console.error('Failed to load image from DB', e);
        }
      }
      
      if (active && fallbackUrl) {
        setImageUrl(fallbackUrl);
      }
    };

    load();

    return () => {
      active = false;
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [imageId, fallbackUrl]);

  return imageUrl;
};
